import service from './service';
import { trimString } from '../utils/common';

export default {
  // 创建
  create(data) {
    return service.post('/api/v1/interview/create', data);
  },

  // 列表
  list(params) {
    params = trimString(params)
    return service.get('/api/v1/interview/list', { params });
  },

  // 个人 拒绝面试邀请
  reject(id, params = {}) {
    params = trimString(params)
    return service.get(`/api/v1/interview/${id}/reject`, { params });
  },

  // 个人 接受面试邀请
  confirm(id, params = {}) {
    params = trimString(params)
    return service.get(`/api/v1/interview/${id}/confirm`, { params });
  },

  // 个人 点击面试邀请后标记为已读
  viewed(id, params = {}) {
    params = trimString(params)
    return service.get(`/api/v1/interview/${id}/viwewd`, { params });
  }
};



// WEBPACK FOOTER //
// ./src/api/interview.js